import { render, staticRenderFns } from "./CarCard.vue?vue&type=template&id=5bedca86&scoped=true&"
import script from "./CarCard.vue?vue&type=script&lang=js&"
export * from "./CarCard.vue?vue&type=script&lang=js&"
import style0 from "./CarCard.vue?vue&type=style&index=0&id=5bedca86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bedca86",
  null
  
)

component.options.__file = "CarCard.vue"
export default component.exports